<script setup>
// BE9: who pays for a match booking. One of the match's players with an
// account, each with their price for the group and whether their rules let
// them book there; a refused payer says why and offers the way out (another
// payer, or choose the playing area later). Used by the time-and-place picker
// and by the accept dialog when agreeing to a suggested time.
import {computed} from 'vue';

const props = defineProps({
  // payerOptions(...) from utils/schedulingPicker
  options: {type: Array, default: () => []},
  refusal: {type: String, default: null},
  hint: {type: String, default: null},
});
const model = defineModel({type: String, default: null});

const items = computed(() => props.options.map((p) => ({
  value: p.userId,
  title: `${p.name}${p.isViewer ? ' (you)' : ''} · ${p.priceLine}${p.canBook ? '' : " · can't book"}`,
})));
</script>

<template>
  <div class="mpp">
    <div class="tl-label mb-2">Who pays for the booking</div>
    <v-select
        v-model="model"
        :items="items"
        item-value="value"
        item-title="title"
        density="compact"
        hide-details
        placeholder="Choose who pays"
    />
    <v-alert v-if="refusal" type="warning" variant="tonal" density="compact" class="mt-2">{{ refusal }}</v-alert>
    <div v-else-if="hint" class="mpp-hint">{{ hint }}</div>
  </div>
</template>

<style scoped>
.mpp-hint {
  font-size: 12px;
  color: rgb(var(--v-theme-textSubtle));
  line-height: 1.5;
  margin-top: 6px;
}
</style>
